import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';
import { ActivityDetailsResultDto } from '../_models/ActivityDetailResultDto';
import { Observable } from 'rxjs';
import { AppConstants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CourseContentMetadataService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = 'CourseContentMetadata/';
  private static readonly GET_ACTIVITY_DETAILS: string = "learner/getactivitydetails/";
  private static readonly GET_RESOURCE_DETAILS: string = "learner/getresourcedetails";

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getActivityDetails$(objectId: string): Observable<ActivityDetailsResultDto> {
    return this.http.get<ActivityDetailsResultDto>(this.baseUrl + CourseContentMetadataService.path + CourseContentMetadataService.GET_ACTIVITY_DETAILS + objectId);
  }

  public getResourceDetails$(objectId: string, courseId: number): Observable<ActivityDetailsResultDto> {
    let params = new HttpParams();
    
    params = params.append(AppConstants.OBJECT_ID, String(objectId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    
    return this.http.get<ActivityDetailsResultDto>(
      this.baseUrl + 
      CourseContentMetadataService.path + 
      CourseContentMetadataService.GET_RESOURCE_DETAILS,
      { params }
    );
  }
}
